import type { Template } from "@/types";

export const LA_03_H3_V0: Template[] = [
    {
        id: "la-03-h3v0-01",
        name: "LA 01 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 63, y: 59, width: 549, height: 365, rotation: 0, imageRotation: 0 },
            { id: "2", x: 882, y: 59, width: 265, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 882, y: 246, width: 265, height: 178, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-02",
        name: "LA 02 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_02.png",
        size: [1352, 483],
        style: {},
        slots: [       
            { id: "1", x: 205, y: 59, width: 265, height: 179, rotation: 0, imageRotation: 0 },
            { id: "2", x: 205, y: 246, width: 265, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 740, y: 59, width: 549, height: 365, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-03",
        name: "LA 03 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 51, y: 50, width: 575, height: 384, rotation: 0, imageRotation: 0 },
            { id: "2", x: 722, y: 144, width: 289, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 144, width: 288, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-04",
        name: "LA 04 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 706, y: 139, width: 305, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 139, width: 304, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-05",
        name: "LA 05 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 42, y: 102, width: 418, height: 279, rotation: 0, imageRotation: 0 },
            { id: "2", x: 468, y: 102, width: 418, height: 279, rotation: 0, imageRotation: 0 },
            { id: "3", x: 894, y: 102, width: 417, height: 279, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-06",
        name: "LA 06 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 29, y: 139, width: 304, height: 206, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 341, y: 139, width: 305, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 676, y: 0, width: 676, height: 483, rotation: 0, imageRotation: 0 }
           
        ],
    },

    {
        id: "la-03-h3v0-07",
        name: "LA 07 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 141, y: 124, width: 352, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 501, y: 124, width: 351, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 860, y: 124, width: 351, height: 236, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-08",
        name: "LA 08 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 84, width: 446, height: 316, rotation: 0, imageRotation: 0 },
            { id: "2", x: 454, y: 84, width: 445, height: 316, rotation: 0, imageRotation: 0 },
            { id: "3", x: 907, y: 84, width: 445, height: 316, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-09",
        name: "LA 09 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_09.png",
        size: [1352, 483],
        style: {},
        slots: [     
            { id: "1", x: 156, y: 36, width: 329, height: 202, rotation: 0, imageRotation: 0 },
            { id: "2", x: 156, y: 246, width: 329, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 645, y: 36, width: 670, height: 410, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h3v0-10",
        name: "LA 10 - H3V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h3_v0_01_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 64, y: 145, width: 287, height: 193, rotation: 0, imageRotation: 0 },
            { id: "2", x: 359, y: 39, width: 635, height: 406, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1002, y: 145, width: 287, height: 193, rotation: 0, imageRotation: 0 }
        ],
    },

];
